// extracted by mini-css-extract-plugin
export var copyIcon = "_si-2";
export var discountCard = "_si-0";
export var discountCode = "_si-3";
export var discountContent = "_si-1";
export var loadingCard = "_si-4";